/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Grid, Modal, Input } from '../../components/index';
import Masks from '../../utils/masks';
import {
  trataMensagemSucesso,
  trataMensagensErro,
} from '../../utils/requests';
import User from '../../domain/User';

const jssPainelMensagemCampoRGPS = {
  display: 'flex',
  padding: '22x',
  borderRadius: '5px',
  backgroundColor:'#e29402',
  color: 'white',
  height: '50px',
  verticalAlign: 'middle',
  marginBottom: '20px',
};

const jssPainelMensagemCampoRPPS = {
  display: 'flex',
  padding: '22x',
  borderRadius: '5px',
  backgroundColor:'#e29402',
  color: 'white',
  height: '80px',
  verticalAlign: 'middle',
  marginBottom: '20px',
};

const jssMensagemDescricao = {
  display: 'inline-block',
  textAlign: 'left',
  verticalAlign: 'middle',
  fontWeight: '600',
  paddingTop: '12px',
  fontSize: '15px',
  marginLeft: '10px',
  flexGrow: '0',
};

class ModalPeriodo extends Component {  
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();;
  }

  getInitialState = () => ({
    touched: false,
    periodoValido: false,
    mostraPainelMensagemCampo: false,
  });
  

  checkIfCanBeSent = () => (
    ( this.state.periodoValido &&
      (this.props.periodo.dataInicio && this.props.periodo.dataInicio.indexOf('_') === -1) &&
      (this.props.periodo.dataFim && this.props.periodo.dataFim.indexOf('_') === -1) 
      && this.state.mostraPainelMensagemCampo === false)
  );

  verificaSeCampoDesabilitado = (name) => {
    if ((name === 'qtdDiasDesconto') &&
      (this.props.periodo.dataInicio && this.props.periodo.dataInicio.indexOf('_') === -1) &&
      (this.props.periodo.dataFim && this.props.periodo.dataFim.indexOf('_') === -1)) {
        return false;
      }
      
      return true;
  }
  trataSucessoResponseEnvio = () => {
    this.handleClose();
    trataMensagemSucesso(['Período alterado com sucesso.']);
  }

  compararDatasInicio = (a, b) => {
    if (moment(a.dataInicio, 'DD/MM/YYYY').toDate() < moment(b.dataInicio, 'DD/MM/YYYY').toDate()) {
      return -1;
    }
    if (moment(a.dataInicio, 'DD/MM/YYYY').toDate() > moment(b.dataInicio, 'DD/MM/YYYY').toDate()) {
      return 1;
    }
    return 0;
  }

  ordenarListaPeriodos = (lista) => {
    lista.sort(this.compararDatasInicio);
    return lista;
  }

  alteraLista = (listaPeriodosCtc, origem) => {
    this.props.handleChange({ value: listaPeriodosCtc, isValid: listaPeriodosCtc.length > 0 }, 'requerimentoPeriodos');
    this.props.atualizarDataIngressoDesvinculacaoETempo(listaPeriodosCtc, origem);
    this.handleClose();
  }

  validarPeriodo(tempo, mensagem) {
  let retorno = false;

    if(tempo > 0) {
      retorno = true;
    } else {
      if (mensagem === 1) {
        trataMensagensErro(['A data de início ou a data de término não corresponde a ano bissexto.']); 
      } else {
        if (mensagem === 2) {
          trataMensagensErro(['O tempo descontado deve ser menor que o tempo de contribuição bruto.']);
        } else {
          trataMensagensErro(['O período é inválido. A data de início deve ser menor que a data de término.']);
        }
      } 
    }
    this.setState({ periodoValido: retorno });
  }

  calcularTempoDeContribuicaoBruto = () => {
    const { periodo, estadoFormulario } = { ...this.props };
    if (periodo) {

      if ((periodo.dataInicio && periodo.dataInicio.indexOf('_') === -1) && 
        (periodo.dataFim && periodo.dataFim.indexOf('_') === -1)) {

        const mesFev = 2;
        const ultimoDiaFevBissexto = 29;
       
        let qtdDiasContribuicaoBruto = 0;
        let tempoContribLiquidoProvisorio = 0;
        let mensagemBissexto = 0;

        let diaInicio = Number(periodo.dataInicio.split('/')[0]);
        let mesInicio = Number(periodo.dataInicio.split('/')[1]);
        let anoInicioBissexto = moment(periodo.dataInicio, 'DD/MM/YYYY').isLeapYear();

        let diaFim = Number(periodo.dataFim.split('/')[0]);   
        let mesFim = Number(periodo.dataFim.split('/')[1]);
        let anoFimBissexto = moment(periodo.dataFim, 'DD/MM/YYYY').isLeapYear();

        if (!(anoInicioBissexto) && mesInicio === mesFev && diaInicio === ultimoDiaFevBissexto ||
          !(anoFimBissexto) && mesFim === mesFev && diaFim === ultimoDiaFevBissexto) {
            mensagemBissexto = 1;
        } else {
          if ((estadoFormulario.requerimento.destinatario && estadoFormulario.requerimento.destinatario === '01000') || 
           (this.props.estadoFormulario.requerimento.destinatario && this.props.estadoFormulario.requerimento.destinatario.codigo === '01000') || 
           (User.logged().isRGPS()) ||
            (this.props.estadoFormulario.requerimento.solicitante && this.props.estadoFormulario.requerimento.solicitante.codigo === '01000'))  {
            qtdDiasContribuicaoBruto = this.props.calcularPeriodoRgps(periodo, false)
          } else {
            qtdDiasContribuicaoBruto = this.props.calcularPeriodoRpps(periodo);
          }

          tempoContribLiquidoProvisorio = qtdDiasContribuicaoBruto - Number(periodo.qtdDiasDesconto);
        }  
        this.props.atualizarTempos(qtdDiasContribuicaoBruto, tempoContribLiquidoProvisorio);   
        this.validarPeriodo(qtdDiasContribuicaoBruto, mensagemBissexto);
      }
    }
    return 0;
  }

  calcularTempoDeContribuicaoLiquido = () => {
    const { periodo } = { ...this.props };
    let mensagemTempoDescontado = 0;
    if (periodo) {
      const qtdDiasDesconto = periodo.qtdDiasDesconto ? Number(periodo.qtdDiasDesconto): 0;
      const tempoBruto = periodo.qtdDiasContribuicaoBruto ? Number(periodo.qtdDiasContribuicaoBruto): 0;
      const qtdDiasContribuicaoLiquido = Math.trunc((tempoBruto - qtdDiasDesconto)); 
      if (qtdDiasContribuicaoLiquido <= 0) {
        mensagemTempoDescontado = 2;
      }
      this.props.atualizarTempoContribuicaoLiquido(qtdDiasContribuicaoLiquido);
      this.validarPeriodo(qtdDiasContribuicaoLiquido, mensagemTempoDescontado);
      this.esconderPainelMensagemCampo();
    }
    return 0;
  }

  handleAdicionarPeriodo = () => {
    const { periodo } = { ...this.props };
    let { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    if (periodo) {
      if (moment(periodo.dataInicio, 'DD/MM/YYYY').toDate() <= moment(periodo.dataFim, 'DD/MM/YYYY').toDate()) {
        requerimentoPeriodos.push(periodo);
        const temConcomitancia = this.props.determinarConcomitancias(requerimentoPeriodos,requerimentoPeriodos.length -1);
        requerimentoPeriodos = this.props.ordenarListaPeriodos(requerimentoPeriodos);
        if (temConcomitancia) {
          const index = requerimentoPeriodos.findIndex(periodo => (periodo.indice === undefined));
          if (index !== -1) {
            requerimentoPeriodos.splice(index, 1);
          }
          trataMensagensErro([`O Período de ${this.props.periodo.dataInicio} até ${this.props.periodo.dataFim} é concomitante com outros períodos existentes na lista.`]);
        } else {
          this.alteraLista(requerimentoPeriodos, 1);
        }
      } else {
        trataMensagensErro([`O Período de ${this.props.periodo.dataInicio} até ${this.props.periodo.dataFim} é inválido.`]);
      }
    }
  }

  handleAlterarPeriodo = () => {
    const { periodo } = { ...this.props };
    let { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    if (periodo) {
      let periodoCopia = requerimentoPeriodos[periodo.indice];
      requerimentoPeriodos[periodo.indice] = periodo;
      const temConcomitancia = this.props.determinarConcomitancias(requerimentoPeriodos,periodo.indice);
      if (temConcomitancia) {
        requerimentoPeriodos[periodo.indice]= periodoCopia;
        trataMensagensErro([`O Período ${this.props.periodo.dataInicio} até ${this.props.periodo.dataFim} é concomitante com outros períodos existentes na lista.`]);
      } else {
        requerimentoPeriodos = this.props.ordenarListaPeriodos(requerimentoPeriodos, periodo.indice);
        const index = requerimentoPeriodos.findIndex(p => (p.indice === periodo.indice));
        if (index !== -1) {
          if (requerimentoPeriodos[index].dataInicio !== periodo.dataInicio) {
            requerimentoPeriodos[index].dataInicio = periodo.dataInicio;
          }
          if (requerimentoPeriodos[index].dataFim !== periodo.dataFim) {
            requerimentoPeriodos[index].dataFim = periodo.dataFim;
          }
          if (requerimentoPeriodos[index].qtdDiasDesconto !== periodo.qtdDiasDesconto) {
            requerimentoPeriodos[index].qtdDiasDesconto = periodo.qtdDiasDesconto;
          }
          if (requerimentoPeriodos[index].qtdDiasContribuicaoBruto !== periodo.qtdDiasContribuicaoBruto) {
            requerimentoPeriodos[index].qtdDiasContribuicaoBruto = periodo.qtdDiasContribuicaoBruto;
          }
          if (requerimentoPeriodos[index].qtdDiasContribuicaoLiquido !== periodo.qtdDiasContribuicaoLiquido) {
            requerimentoPeriodos[index].qtdDiasContribuicaoLiquido = periodo.qtdDiasContribuicaoLiquido;
          }
          if (periodo.idPeriodo) {
            requerimentoPeriodos[index].operacao = periodo.operacao;
          } else {
            requerimentoPeriodos[index].operacao = 1;
          }
        }
        this.alteraLista(requerimentoPeriodos, 2);
      }
    }
  }

  mostraPainelMensagemCampo = () => {
    this.setState({ mostraPainelMensagemCampo: true });
  }
  
  esconderPainelMensagemCampo = () => {
    this.setState({ mostraPainelMensagemCampo: false });
  }

  painelMensagemCampo = () => {
    if (User.logged().isRGPS()) {
      const mensagemCampoParagrafo1RGPS=(<p>O campo 'Tempo Descontado' deve ser utilizado para ajustar o tempo certificado e efetivamente utilizado no período acima.</p>);
      return (
        <React.Fragment>
          {mensagemCampoParagrafo1RGPS}
        </React.Fragment>
      );
    } else {
      const mensagemCampoParagrafo1RPPS=(<p>O campo 'Tempo Descontado' deve ser utilizado para ajustar o tempo certificado e efetivamente utilizado no período acima.</p>);
      const mensagemCampoParagrafo2RPPS=(<p>Se necessário, fracione os períodos que contenham deduções (faltas acima de 30 dias consecutivos; licenças; etc.).</p>);
      return (
        <React.Fragment>
          {mensagemCampoParagrafo1RPPS}
          {mensagemCampoParagrafo2RPPS}
        </React.Fragment>
      );
    }
  }

  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            label="Data de início"
            onChange={e => this.props.handleChangePeriodos(e, 'dataInicio')}
            value={this.props.periodo.dataInicio}
            onBlur={e => this.calcularTempoDeContribuicaoBruto()}
            mask={Masks.date}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            label="Data de término"
            onChange={e => this.props.handleChangePeriodos(e, 'dataFim')}
            onBlur={e => this.calcularTempoDeContribuicaoBruto()}
            value={this.props.periodo.dataFim}
            mask={Masks.date}

          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            label="Tempo de contribuição bruto"
            value={this.props.periodo.qtdDiasContribuicaoBruto > 0 ? this.props.periodo.qtdDiasContribuicaoBruto : ''}
            disabled
          />
        </Grid>
        <Grid cols="2 2 2 2">
          <Input
            label="Tempo descontado"
            value={this.props.periodo.qtdDiasDesconto}
            disabled={this.verificaSeCampoDesabilitado('qtdDiasDesconto')}
            onBlur={e => this.calcularTempoDeContribuicaoLiquido()}
            onFocus={e => this.mostraPainelMensagemCampo()}
            onChange={e => this.props.handleChangePeriodos(e, 'qtdDiasDesconto')}
            integer
            number
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            label="Tempo de contribuição liquido"
            value={this.props.periodo.qtdDiasContribuicaoLiquido > 0 ? this.props.periodo.qtdDiasContribuicaoLiquido : ''}
            disabled
          />
        </Grid>
      </div>
      {this.state.mostraPainelMensagemCampo &&
        <div style={(User.logged() && User.logged().isRGPS()) ? jssPainelMensagemCampoRGPS : jssPainelMensagemCampoRPPS}>
          <div  style={jssMensagemDescricao}> 
            {this.painelMensagemCampo()}
          </div>
        </div>
      } 
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfCanBeSent()}
          hint="Adicionar período"
          onClick={(this.props.periodo.operacao && this.props.periodo.operacao === 2)
            ? this.handleAlterarPeriodo : this.handleAdicionarPeriodo}
          title={(this.props.periodo.operacao && this.props.periodo.operacao === 2)
            ? "Alterar" : "Adicionar"}
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    const { periodo } = { ...this.state };
    this.setState({
      periodo: {
        ...periodo,
        [name]: changeObj.value,
      },
    });
  }

  handleClose = () => {
    this.setState(this.props.handleModal('showModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModal}
        title={(this.props.periodo.operacao && this.props.periodo.operacao === 2)
        ? 'alterar Período' : 'adicionar Período'}
        hint={(this.props.periodo.operacao && this.props.periodo.operacao === 2)
        ? 'alterar Período' : 'adicionar Período'}
      />
    );
  }
}

ModalPeriodo.propTypes = {
  periodo: PropTypes.objectOf(PropTypes.object).isRequired,
  showModal: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleChangePeriodos: PropTypes.func.isRequired,
  atualizarDataIngressoDesvinculacaoETempo: PropTypes.func.isRequired,
  atualizarTempos: PropTypes.func.isRequired,
  atualizarTempoContribuicaoLiquido: PropTypes.func.isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  determinarConcomitancias: PropTypes.func.isRequired,
  ordenarListaPeriodos: PropTypes.func.isRequired,
  calcularPeriodoRgps: PropTypes.func.isRequired,
  calcularPeriodoRpps: PropTypes.func.isRequired,
}.isRequired;

export default ModalPeriodo;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalPeriodo.jsx